import * as Api from '@ViewModels';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { AUTOMATION_QUERY_KEYS, AUTOMATION_TEMPLATE_MUTATION_KEY } from '../Automation/queryKeys';

interface StepOrderParams {
	id: string;
	order: string[];
	impersonationContext?: Api.IImpersonationContext;
}

export function useAutomationTemplateIdStepOrderUpdateMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (value: string[], variables: StepOrderParams) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();
	const queryClient = useQueryClient();
	return useMutation({
		mutationKey: AUTOMATION_TEMPLATE_MUTATION_KEY,
		mutationFn: ({ id, order, impersonationContext }: StepOrderParams) => {
			return userSession.webServiceHelper.callAsync<string[]>(
				Api.ImpersonationBroker.composeApiUrl({ urlPath: `automationTemplate/${id}/stepOrder`, impersonationContext }),
				'PUT',
				order
			);
		},
		onSuccess: (data, variables) => {
			queryClient.invalidateQueries({ queryKey: AUTOMATION_QUERY_KEYS.template(variables.id) });
			onSuccess?.(data, variables);
		},
		onError,
	});
}
